<template>
    <div class="socials-container">
        <div class="logo" v-for="(item, index) in filteredSocials" :key="index">
            <a
                :href="item.url"
                target="_blank"
                rel="noopener"
                :aria-label="item.platform"
                class="social-link"
                @mouseover="showTooltip(item.platform)"
                @mouseleave="hideTooltip"
            >
                <ion-icon :name="`logo-${item.platform.toLowerCase()}`"></ion-icon>
                <span class="tooltip" v-if="activeTooltip === item.platform">{{ item.platform }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocialsComponent',
    props: {
        socials: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            activeTooltip: null,
        };
    },
    computed: {
        filteredSocials() {
            return Object.entries(this.socials)
                .filter(([url]) => url)
                .map(([platform, url]) => ({
                    platform: platform.charAt(0).toUpperCase() + platform.slice(1),
                    url
                }));
        }
    },
    methods: {
        showTooltip(platform) {
            this.activeTooltip = platform;
        },
        hideTooltip() {
            this.activeTooltip = null;
        }
    }
}
</script>